import { render, staticRenderFns } from "./VerkInvoiceSyncList.vue?vue&type=template&id=2fe8ec5d&scoped=true&"
import script from "./VerkInvoiceSyncList.vue?vue&type=script&lang=ts&"
export * from "./VerkInvoiceSyncList.vue?vue&type=script&lang=ts&"
import style0 from "./VerkInvoiceSyncList.vue?vue&type=style&index=0&id=2fe8ec5d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fe8ec5d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VRow})
